import { Page } from 'corso-admin-ui';
import SearchTable from '~/components/searchTable/SearchTable';
import { useStoreId } from '~/providers/StoreUserProvider';

export default function ShippingClaimsTablePage() {
  const storeId = useStoreId();

  return (
    <Page
      title="Shipping"
      size="fullWidth"
      primaryAction={{
        to: `/${storeId}/orders/lookup`,
        content: 'Order Lookup',
      }}
    >
      <SearchTable />
    </Page>
  );
}
